// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowBackInactive: React.FC = () => {
    return (
        <svg width="5" height="10">
            <path
                fill="CurrentColor"
                d="M3.916 9.298.172 5.196A.657.657 0 0 1 0 4.75c0-.16.057-.32.172-.445L3.916.202a.615.615 0 0 1 .887-.025.662.662 0 0 1 .025.916L1.468 4.75l3.36 3.658a.662.662 0 0 1-.025.916.616.616 0 0 1-.887-.026Z"
            />
        </svg>
    );
};

export default React.memo(IconArrowBackInactive);
